export default {
  props: ['cart_total'],
  data() {
    return {
      incentive: this.findIncentive(this.cart_total),
      barWidth: 0
    }
  },
  async mounted() {
    this.barWidth = this.width(this.cart_total);
    // works out if need to add gifts from incentives already fulfilled
    if ((store.getters.incentives.length) > 0) {
      for ( let initialIncentive of store.getters.incentives.filter(i => i.type === "gift") ) {
        if (!store.getters.cart.items.find(p => p.id == initialIncentive.gift_id)) {
          if ((initialIncentive.incentive_threshold * 100) <= this.cart_total ) await this.addtoCart(initialIncentive.gift_id)
        }
      }
    }
  },
  methods: {
    formatPrice(num) {
      return `$${(num / 100.0).toFixed(2)}`
    },
    moneyToGo() {
      if (!this.incentive) return 0
      return ((this.incentive.incentive_threshold * 100) - this.cart_total)
    },
    width(n) {
      if (!this.incentive) return 100
      const percent = (n - (this.incentive.incentive_start * 100)) / (this.incentive.incentive_threshold - this.incentive.incentive_start)
      return (percent > 100) ? 100 : percent
    },
    findIncentive(total) {
      return store.getters.incentives
        .sort((a, b) => a.incentive_start - b.incentive_start)
        .find((i => total >= i.incentive_start * 100 && total < i.incentive_threshold * 100))
    },
    async addtoCart(id) {
      await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: id,
          quantity: 1,
          properties: {
            gift: "You've earned a free gift"
          }
        })
      })
    },
    async removeFromCart(id) {
      const payload = { updates: {}}
      payload.updates[id] = 0
      await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
    }
  },
  computed: {
    isFull() {
      return this.barWidth >= 100
    },
    incentives() {
      return store.getters.incentives
    }
  },
  watch: {
    async cart_total(n, o) {
      this.incentive = this.findIncentive(n)
      this.barWidth = this.width(n)
      if (this.findIncentive(o) === this.findIncentive(n)) return // no change in incentive
    
      if (n > o) {
        var validIncentives = store.getters.incentives.filter(i => i.type === "gift" && (i.incentive_threshold < (n/100)));
        for (let validIncentive of validIncentives) {
          if(!store.getters.cart.items.find(p => p.id == validIncentive.gift_id)) {
            await this.addtoCart(validIncentive.gift_id)
          }
        }
        
        this.barWidth = 100;
        setTimeout(() => {
          this.barWidth = 0
        }, 1000)
        setTimeout(() => {
          this.barWidth = this.width(n)
        }, 1200)
      }

      if (n < o) {
        var incentives = store.getters.incentives.filter(i => i.type === "gift");
        for (let invalidIncentive of incentives) {
          if (invalidIncentive.incentive_threshold > (n/100)) await this.removeFromCart( invalidIncentive.gift_id )
        }
        this.barWidth = 0;
        setTimeout(() => {
          this.barWidth = 99
        }, 1000)
        setTimeout(() => {
          this.barWidth = this.width(n)
        }, 1200)
      }
    }
  },
  template:`
  <div class="progress_bar_section" :class="{ full : isFull }">
    <p v-if="cart_total >= 0 && this.incentive" class="progress_bar_title">Add {{formatPrice(this.moneyToGo())}} to unlock {{this.incentive.incentive_text}} </p>
    <p v-else class="progress_bar_title">You've unlocked {{ incentives[incentives.length - 1].incentive_text }}</p>
    <div class="progress_bar_wrapper">  
      <div v-if=" this.barWidth < 100" class="vue_progress_bar" :style="{ width: this.barWidth + '%' }"></div>
      <div v-else class="vue_progress_bar" style="width:100%"></div>
    </div>
  </div>
  `
}